import React, { useState } from 'react';
import { X, ChevronLeft, ChevronRight, Image } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
const galleryImages = [{
  id: 1,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1705531212807-8K5QBL8124KSZAZSZDD5/IMG_2461.jpg'
}, {
  id: 2,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1600902323950-7505MEPRWJ0NGMIJ8OIR/31166905_10214097805092351_8855011503833612288_n.jpg'
}, {
  id: 3,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1600902324696-IH11I6W1VUYSW1MMXB9H/TEAM+5.jpg'
}, {
  id: 4,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1600902335337-K4JJF4WCTDB903H1K35D/TEAM+8.jpg'
}, {
  id: 5,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1600902331614-MZJOM0XYGM6DC18FMS85/TEAM+9.jpg'
}, {
  id: 6,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1600902356369-EQ9IER1IFHTCAZWAJGLK/48329472_10215934798114462_6586296279280648192_o.jpg'
}, {
  id: 7,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1600902343902-DCHG5XRNV1PR26MXG047/TEAM+10.jpg'
}, {
  id: 8,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1600902356269-W6WJ402XQ4RYBPUNSE6T/85058660_1412966432206505_2223528947373572096_o.jpg'
}, {
  id: 9,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1600902345658-3H3JNBJ6VM0I15QZLF90/TEAM2.jpg'
}, {
  id: 10,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1600902359706-N7MA6A2XCNDCWVFRRDV9/88008530_1413270435509438_4277745336136499200_o.jpg'
}, {
  id: 11,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1600902408785-AH572ZHO9UAMBNIC8P3M/14525186_622917771211379_4035162346513061770_o.jpg'
}, {
  id: 12,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1600902408264-9MMJ8OXC919ZX8J4LBSJ/14568214_10154791902282214_4636518316449056010_n.jpg'
}, {
  id: 13,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1600902361500-9JZC43BLSGRN8AMXB6B9/Pic+56.jpg'
}, {
  id: 14,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1600902409625-X243B41P2V1IZ1MM9EP3/15941248_10210036362078814_6182659003023785477_n.jpg'
}, {
  id: 15,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1600902409249-0Q0U994JFQ6FQPUUWERZ/17201217_10210566448850652_5510955046909524757_n.jpg'
}, {
  id: 16,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1600902409692-7W24K0PI0ZPWO0ICFRR6/64974434_1202972936539190_3592335123393019904_o.jpg'
}, {
  id: 17,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1600902410062-K7W4FYV77Y7XEE5BQINV/74390306_10158127730517214_4728457224198815744_n.jpg'
}, {
  id: 18,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1600902508307-XVLF1M2397191W8R63CF/21686256_797792007057287_316822438608478779_n.jpg'
}, {
  id: 19,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1600902360040-DLH2GTM04T55JA5OL5AM/89029680_1412965725539909_5430538331026882560_o.jpg'
}, {
  id: 20,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1600902410881-QSOG24VRH2WIJSUPVVC3/crying.jpg'
}, {
  id: 21,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1600902509136-4Y99TY3QOYPYPP6XX7Q6/52740123_1119836584852826_2234337558991470592_o.jpg'
}, {
  id: 22,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1600902413528-RC7A7FUPQPLQF3JN7NX0/jorjor+smash.jpg'
}, {
  id: 23,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1600902510644-861VFLCHD6F4AJV4WAYW/HUI.jpg'
}, {
  id: 24,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1600902416559-XIWNPKW7POQAB5BZUW35/joseph+and+kids.jpg'
}, {
  id: 25,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1600902414150-UGSVCY510ZHM211EBULP/remmington+belt.jpg'
}, {
  id: 26,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1602023289799-DVNMDVGOBZFHPI5TQLHI/15672708_662028550633634_7480491408935996975_n.jpg'
}, {
  id: 27,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1602023291541-QH6BNTNSVDKWY9DTVA3O/18622272_739088136261008_906762982716916196_n.jpg'
}, {
  id: 28,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1602023291837-YU16ICN7W2FTC0C8EDY8/48083604_10157212146357214_4049736590522580992_o.jpg'
}, {
  id: 29,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1602023374885-W7ZIJW82DY0LECNZ2W9G/DSC_0204.JPG'
}, {
  id: 30,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1602023318561-JL4ZNNMEOTABQSNDBXWW/ryan+laser.jpg'
}, {
  id: 31,
  url: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1602023375285-AW34XFHTF1PUNJ704N9W/DSC_0573.JPG'
}];
export function GalleryPage() {
  const [lightboxImage, setLightboxImage] = useState<number | null>(null);
  const openLightbox = (id: number) => setLightboxImage(id);
  const closeLightbox = () => setLightboxImage(null);
  const navigateLightbox = (direction: 'prev' | 'next') => {
    if (lightboxImage === null) return;
    const currentIndex = galleryImages.findIndex(img => img.id === lightboxImage);
    let newIndex;
    if (direction === 'prev') {
      newIndex = currentIndex > 0 ? currentIndex - 1 : galleryImages.length - 1;
    } else {
      newIndex = currentIndex < galleryImages.length - 1 ? currentIndex + 1 : 0;
    }
    setLightboxImage(galleryImages[newIndex].id);
  };
  const currentImage = galleryImages.find(img => img.id === lightboxImage);
  return <main className="pt-40 pb-20 bg-gray-50" data-id="element-473">
      <div className="bg-primary text-white py-16 mb-12" data-id="element-474">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-475">
          <Image className="w-16 h-16 mx-auto mb-6 text-gold" data-id="element-476" />
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-477">Gallery</h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto" data-id="element-478">
            See our students in action—from daily classes to belt tests and
            community events.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-479">
        {/* Gallery Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-16" data-id="element-480">
          {galleryImages.map((image, index) => <motion.div key={image.id} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.02
        }} className="group relative aspect-square overflow-hidden rounded-xl bg-gray-200 cursor-pointer shadow-sm hover:shadow-xl transition-shadow" onClick={() => openLightbox(image.id)} data-id="element-481">
              <img src={image.url} alt={`Gallery image ${image.id}`} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-482" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/0 to-black/0 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-483" />
            </motion.div>)}
        </div>

        {/* CTA Section */}
        <div className="bg-primary rounded-2xl p-8 md:p-12 text-center text-white" data-id="element-484">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-485">
            Ready to Be Part of Our Story?
          </h2>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto" data-id="element-486">
            Join our Brighton community and create your own success story. Start
            your journey with our 4-week trial today.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-487">
            <Link to="/trial" data-id="element-488">
              <Button size="lg" className="bg-accent hover:bg-accent-dark text-white border-none" data-id="element-489">
                Start Your 4-Week Trial
              </Button>
            </Link>
            <Link to="/contact" data-id="element-490">
              <Button size="lg" variant="outline" className="border-white text-white hover:bg-white/10" data-id="element-491">
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {/* Lightbox */}
      <AnimatePresence data-id="element-492">
        {lightboxImage !== null && currentImage && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4" onClick={closeLightbox} data-id="element-493">
            <button onClick={closeLightbox} className="absolute top-4 right-4 text-white hover:text-accent transition-colors z-10" aria-label="Close" data-id="element-494">
              <X className="w-8 h-8" data-id="element-495" />
            </button>

            <button onClick={e => {
          e.stopPropagation();
          navigateLightbox('prev');
        }} className="absolute left-4 text-white hover:text-accent transition-colors z-10" aria-label="Previous" data-id="element-496">
              <ChevronLeft className="w-12 h-12" data-id="element-497" />
            </button>

            <button onClick={e => {
          e.stopPropagation();
          navigateLightbox('next');
        }} className="absolute right-4 text-white hover:text-accent transition-colors z-10" aria-label="Next" data-id="element-498">
              <ChevronRight className="w-12 h-12" data-id="element-499" />
            </button>

            <div className="max-w-6xl w-full" onClick={e => e.stopPropagation()} data-id="element-500">
              <motion.img key={currentImage.id} initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.9
          }} src={currentImage.url} alt={`Gallery image ${currentImage.id}`} className="w-full h-auto max-h-[85vh] object-contain rounded-lg" data-id="element-501" />
            </div>
          </motion.div>}
      </AnimatePresence>
    </main>;
}